import { Button } from '@/components/atoms/Button'
import { Label } from '@/components/atoms/Label'
import { Panel } from '@/components/atoms/Panel'
import { LabeledInputField } from '@/components/molecules'
import { trpc } from '@/config/trpc'
import { useState } from 'react'

type CreateApiKeyProps = {
  customerUUID: string
  refetch: () => void
}

export function CreateApiKey({ customerUUID, refetch }: CreateApiKeyProps) {
  const { mutateAsync } = trpc.addApiKey.useMutation()

  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [requestsPerMinute, setRequestsPerMinute] = useState('')
  const [name, setName] = useState('')
  const [isPro, setIsPro] = useState(false)

  const [generatedKey, setGeneratedKey] = useState('')

  const handleAddCustomerClick = async () => {
    try {
      setButtonDisabled(true)

      const { status, key } = await mutateAsync({
        customerUUID,
        name,
        requestsPerMinute: Number(requestsPerMinute),
        isPro,
      })
      if (status === 'Success') {
        try {
          await navigator.clipboard.writeText(key)
          window.alert('API key copied to clipboard')
        } catch {}
        setGeneratedKey(key)
        refetch()
      }
    } catch (e) {
      window.alert(e)
    } finally {
      setButtonDisabled(false)
    }
  }

  return (
    <Panel>
      {generatedKey && (
        <div className="flex flex-col gap-4">
          <Label className="my-5 text-3xl text-bold ">Generated key - shown only once</Label>
          <span className="text-2xl">{generatedKey}</span>
        </div>
      )}
      <Label className="my-5 text-bold text-xl ">Add new api key</Label>
      <div className="flex flex-col gap-4">
        <LabeledInputField label="Name" value={name} onChange={(e) => setName(e.target.value)} />
        <LabeledInputField
          label="Requests per minute"
          value={requestsPerMinute}
          onChange={(e) => setRequestsPerMinute(e.target.value)}
        />
        <LabeledInputField
          label="Is Pro"
          type="checkbox"
          checked={isPro}
          className="h-4 w-4"
          onChange={(e) => setIsPro(e.target.checked)}
        />
        <Button className="w-full gap-2" disabled={buttonDisabled} onClick={handleAddCustomerClick}>
          Create API Key
        </Button>
      </div>
    </Panel>
  )
}
